<div class="layers-container" *ngrxLet="selectionLayers$ as selectionLayers">
    <ng-container *ngIf="selectionLayers.length">
        <app-layer-group
            class="group"
            [groupInfo]="{ name: 'Selections', id: 'Selections' }"
            [layers]="(selectionLayers$ | async) ?? []"
            [showToggleAllButtons]="true"
            (selectLayer)="toggleLayerDetailOverlay($event)"
            (selectLayerGroup)="toggleLayerGroupOverlay($event)"
        >
        </app-layer-group>
    </ng-container>

    <ng-container *ngIf="showHierarchicalSelectionLayers$ | async">
        <div *ngIf="selectionGroup$.length" class="group">
            <div class="title-row" #titleElement>Hierarchical Selections</div>
            <div *ngFor="let group of selectionGroup$">
                <app-layer-group
                    class="group hierarchical-selections-group"
                    [groupInfo]="{ name: group.name, id: group.name }"
                    [layers]="group.selections"
                    [showToggleAllButtons]="true"
                    (selectLayer)="toggleLayerDetailOverlay($event)"
                    (selectLayerGroup)="toggleLayerGroupOverlay($event)"
                >
                </app-layer-group>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="showUnsupervisedSelectionLayers$ | async">
        <div *ngIf="unsupervisedSelectionGroup$.length" class="group">
            <div class="title-row" #titleElement>Unsupervised Selections</div>
            <div *ngFor="let group of unsupervisedSelectionGroup$">
                <app-layer-group
                    class="group hierarchical-selections-group"
                    [groupInfo]="{ name: group.name, id: group.name }"
                    [layers]="group.selections"
                    [showToggleAllButtons]="true"
                    (selectLayer)="toggleLayerDetailOverlay($event)"
                    (selectLayerGroup)="toggleLayerGroupOverlay($event)"
                >
                </app-layer-group>
            </div>
        </div>
    </ng-container>

    <ng-container *ngrxLet="viewerLayers.layerGroups$ as layerGroups">
        <app-layer-groups
            [layerGroups]="layerGroups"
            (layerSelected)="toggleLayerDetailOverlay($event)"
            (layerGroupSelected)="toggleLayerGroupOverlay($event)"
        ></app-layer-groups>
    </ng-container>
</div>

<ng-template cdkPortal>
    <ng-container *ngIf="detailView$ | async; else allLayers">
        <ng-container *ngrxLet="detailViewLayer$ as layer">
            <div class="single-layer-detail-overlay">
                <app-single-layer-detail
                    (close)="closeLayerDetailOverlay()"
                    [layer]="layer"
                    [colorPalette]="colorPalette"
                ></app-single-layer-detail>
            </div>
        </ng-container>
    </ng-container>
    <ng-template #allLayers>
        <ng-container *ngrxLet="viewAllLayers$ as layers">
            <ng-container *ngrxLet="layerGroupOverlayTitle$ as title">
                <div class="layer-group-detail-overlay">
                    <app-layer-group-detail
                        (close)="closeLayerGroupOverlay()"
                        [layers]="layers"
                        [title]="title"
                    ></app-layer-group-detail>
                </div>
            </ng-container>
        </ng-container>
    </ng-template>
</ng-template>
